import {makeItem} from "../Item";

export const FineSandBottle = makeItem(4, "Fine Sand Bottle", "item");
export const UntamedFlame = makeItem(5, "Untamed Flame", "item");
export const CoarseAlluvium = makeItem(9, "CoarseAlluvium", "item");
export const FlyingSprout = makeItem(14, "Flying Sprout", "item");
export const BlisteringOre = makeItem(15, "Blistering Ore", "item");
export const HollowSoul = makeItem(28, "Hollow Soul", "item");
export const Lacrimosa = makeItem(29, "Lacrimosa", "item");
export const IronCluster = makeItem(34, "Iron Cluster", "item");
export const SandBrick = makeItem(52, "Sand Brick", "item");
export const AntiqueCloth = makeItem(54, "Antique Cloth", "item");
export const ProsperityFlame = makeItem(69, "Prosperity Flame", "item");
export const ExplosiveMaterial = makeItem(70, "Explosive Material", "item");
export const SteelLiquid = makeItem(71, "Steel Liquid", "item");

export const BastionBlock = makeItem(120, "Bastion Block", "item");
export const CorrodedCartridge = makeItem(121, "Corroded Cartridge", "item");
export const RawGemstone = makeItem(124, "Raw Gemstone", "item");
export const GraySandstone = makeItem(125, "Gray Sandstone", "item");
export const KlugerHerb = makeItem(126, "Kluger Herb", "item");
export const MeditativeSutra = makeItem(127, "Meditative Sutra", "item");
export const JumboBeastBone = makeItem(128, "Jumbo Beast Bone", "item");
export const BestiaFruit = makeItem(129, "Bestia Fruit", "item");
export const ToxicTulip = makeItem(130, "Toxic Tulip", "item");
export const RhemPepper = makeItem(144, "Rhem Pepper", "item");
export const RustyEave = makeItem(145, "Rusty Eave", "item");
export const TranslucentSilk = makeItem(146, "Translucent Silk", "item");
export const DustyBook = makeItem(147, "Dusty Book", "item");
export const BrokenTeacup = makeItem(148, "Broken Teacup", "item");